const useDifficultLevelsList = () => {
  return [
    {
      id: 1,
      name: "1"
    },
    {
      id: 2,
      name: "2"
    },
    {
      id: 3,
      name: "3"
    }
  ]
}

export default useDifficultLevelsList
